import { render, staticRenderFns } from "./VueGauge.vue?vue&type=template&id=44e6e098&"
import script from "./VueGauge.vue?vue&type=script&lang=js&"
export * from "./VueGauge.vue?vue&type=script&lang=js&"
import style0 from "./VueGauge.vue?vue&type=style&index=0&lang=stylus&scope=this%20api%20replaced%20by%20slot-scope%20in%202.5.0%2B&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
